// Modules
import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

// Components
import Button from "../button";
import CustomGatsbyImage from "../gatsbyImage";

// Styles
import * as styles from "./columns.module.scss";

const ColumnsItem = (props) => {
  const {
    isBorder,
    hideNumber,
    icon,
    link,
    newTabLink,
    numberColor,
    numberIcon,
    substring,
    title,
    titleColor,
    type,
    button,
  } = props;

  const numberStyle = { borderColor: numberColor, color: numberColor };
  const titleStyle = { color: titleColor };
  return (
    <div
      className={cx({ [styles.columnsItem]: true, [styles.divider]: isBorder })}
    >
      {!hideNumber && (
        <div className={styles.numberIcon} style={numberStyle}>
          <span>{numberIcon}</span>
        </div>
      )}
      {icon && icon.image && icon.image.asset && (
        <div className={styles.icon}>
          <CustomGatsbyImage
            alt={icon.alt}
            img={icon.image.asset}
            type={type}
          />
        </div>
      )}
      {icon?.title && <div className={styles.h5}>{icon.title}</div>}
      <h3 style={titleStyle}>{title}</h3>
      <p>{substring}</p>
      {button && (
        <Button
          classNameBtn={cx("raleway-xxs-bold", styles.button)}
          label={button?.label || "Find out more"}
          link={link}
          newTab={newTabLink}
          type={button?.type || "btn-pink"}
        />
      )}
    </div>
  );
};

ColumnsItem.propTypes = {
  hideNumber: PropTypes.bool,
  icon: PropTypes.shape({
    alt: PropTypes.string,
    image: PropTypes.shape({
      asset: PropTypes.object,
      title: PropTypes.string,
    }),
  }),
  link: PropTypes.string,
  newTabLink: PropTypes.bool,
  numberColor: PropTypes.string,
  numberIcon: PropTypes.number,
  substring: PropTypes.string,
  title: PropTypes.string,
  titleColor: PropTypes.string,
  type: PropTypes.string,
  button: PropTypes.shape({ type: PropTypes.string, label: PropTypes.string }),
};

ColumnsItem.defaultProps = {
  hideNumber: true,
  link: "",
  newTabLink: false,
  numberColor: "",
  numberIcon: 1,
  substring: "",
  title: "",
  titleColor: "",
  type: "",
  button: undefined,
};

export default ColumnsItem;
